/* eslint-disable @typescript-eslint/no-explicit-any */
import { MotifRichTextEditor } from "@ey-xd/motif-react";

interface RichTextEditorProps {
  placeholder?: string;
  value: string;
  name?: string;
  readOnly?: boolean;
  className?: string;
  handleChange?: (event: {
    target: {
      name: string;
      value: string;
    };
  }) => void;
}
export function RichTextEditor({
  placeholder,
  value,
  readOnly = false,
  name,
  handleChange,
  className,
}: RichTextEditorProps) {
  const editorModules = {
    toolbar: [
      [
        {
          header: "1",
        },
        {
          header: "2",
        },
        {
          font: [],
        },
      ],
      [
        {
          size: [],
        },
      ],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        {
          list: "ordered",
        },
        {
          list: "bullet",
        },
        {
          indent: "-1",
        },
        {
          indent: "+1",
        },
      ],
      ["link"],
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  const handleChangeHandler = (val: string, _delta: any, _source: any) => {
    const event = {
      target: {
        name: name || "",
        value: val,
      },
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    _source === "user" && handleChange && handleChange(event);
  };

  const editorFormats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "indent",
    "link",
  ];

  return (
    <>
      <MotifRichTextEditor
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        readOnly={readOnly}
        placeholder={placeholder || "Description"}
        onChange={handleChangeHandler}
        value={value}
        modules={editorModules}
        formats={editorFormats}
        className={className}
      />
    </>
  );
}  
